import { CloseIcon } from '@/components/base/Icons/RocheIconPack';
import { translateDynamicKey } from '@/types/translation';
import IconButton from '@/storybook/components/IconButton/IconButton';
import { ArrowPosition } from '@/types/ui';
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react';
import cx from 'classnames';
import { ReactElement, ReactNode, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { usePopper } from 'react-popper';
import styles from './FilterInfoPopup.module.scss';

interface FilterInfoPopupProps {
  title: string;
  content: ReactNode;
  trigger: ReactElement;
  arrowPosition?: ArrowPosition;
  isTriggerIcon?: boolean;
}

const FilterInfoPopup = ({ title, content, trigger, arrowPosition, isTriggerIcon = true }: FilterInfoPopupProps) => {
  const { t } = useTranslation();
  const [chipRef, setChipRef] = useState<HTMLButtonElement | null>(null);
  const [panelRef, setPanelRef] = useState<HTMLElement | null>(null);
  const { styles: popperStyles, attributes } = usePopper(chipRef, panelRef, {
    modifiers: [{ name: 'offset', options: { offset: [0, 10] } }],
    placement: 'bottom',
  });

  return (
    <Popover
      className={cx(styles.popoverWrapper, {
        [styles.isTriggerIcon]: isTriggerIcon,
      })}
    >
      <PopoverButton
        className={cx(styles.popupTrigger, {
          [styles.isTriggerIcon]: isTriggerIcon,
        })}
        ref={setChipRef}
      >
        {trigger}
      </PopoverButton>
      <PopoverPanel className={styles.popup} ref={setPanelRef} style={popperStyles.popper} {...attributes.popper}>
        <div className={styles.headerWrapper}>
          <h3>{translateDynamicKey(t, title)}</h3>
          <PopoverButton as={IconButton} appearance="text" icon={<CloseIcon />} />
        </div>
        <div className={styles.contentWrapper}>
          <p className={styles.content}>{typeof content === 'string' ? translateDynamicKey(t, content) : content}</p>
        </div>
        <div className={styles.arrow} style={arrowPosition} />
      </PopoverPanel>
    </Popover>
  );
};
export default FilterInfoPopup;
